// @flow
import 'react-resizable/css/styles.css'

import FormHeaderTeam from 'components/FormCustomer/FormHeaderTeam'
import UnauthorizedPage from 'components/UnauthorizedPage'
import usePermissions from 'hooks/usePermissions'
import useSignatureMemo from 'hooks/useSignatureMemo'
import PdfFillerContextProvider, {
  PDFFillerContext,
} from 'pages/Contexts/PdfFillerContext'
import * as React from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { Helmet } from 'react-helmet'
import FullHeightContainer from 'ui/atoms/FullHeightContainer'
import Page from 'ui/organisms/Page'

import DocumentSection from '../PDFFiller/Components/DocumentSection'

function PreviewDocument(): React.Node {
  const localSignatureMemo = useSignatureMemo('preview')

  const { canViewResponse } = usePermissions()

  if (!canViewResponse) return <UnauthorizedPage />

  return (
    <FullHeightContainer $offset={0}>
      <PdfFillerContextProvider
        signatureMemo={localSignatureMemo}
        viewMode="preview"
      >
        <Helmet>
          <meta
            content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
            name="viewport"
          />
        </Helmet>
        <PDFFillerContext.Consumer>
          {({ viewMode, isSubmitted, teamDetails, redirectUrl }) => {
            const hideHeader = !teamDetails
            return (
              <>
                {!hideHeader ? <FormHeaderTeam team={teamDetails} /> : null}
                <Page fluid>
                  <DndProvider backend={HTML5Backend}>
                    <DocumentSection />
                  </DndProvider>
                </Page>
              </>
            )
          }}
        </PDFFillerContext.Consumer>
      </PdfFillerContextProvider>
    </FullHeightContainer>
  )
}

export default PreviewDocument
